import { render, staticRenderFns } from "./HeaderAdminWeddbets.vue?vue&type=template&id=39977895&scoped=true&"
import script from "./HeaderAdminWeddbets.vue?vue&type=script&lang=js&"
export * from "./HeaderAdminWeddbets.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAdminWeddbets.vue?vue&type=style&index=0&id=39977895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39977895",
  null
  
)

export default component.exports